import React from "react"
import * as PropTypes from "prop-types"
import FileInput from "react-fine-uploader/file-input"
import ProgressBar from "react-fine-uploader/progress-bar"
import FineUploaderTraditional from "fine-uploader-wrappers/traditional"
import FineUploaderS3 from "fine-uploader-wrappers/s3"
import style from "./index.module.css"

export default class Uploader extends React.Component {

  static propTypes = {
    onSuccess: PropTypes.func,
    accept: PropTypes.string,
    fineUploaderOptions: PropTypes.object,
    type: PropTypes.string
  }

  constructor(props) {
    super(props)
    var params = {options: props.fineUploaderOptions};
    this.uploader = props.type === 's3' ? new FineUploaderS3(params) : new FineUploaderTraditional(params);
    this.state = {
      uploadStatus: null, // SUCCESS, PROGRESS, ERROR, null
      uploadPublicUrl: null,
      uploadValidationErrors: null,
    }
  }

  componentDidMount() {
    // see all events: https://docs.fineuploader.com/branch/master/api/events.html
    this.uploader.on("submit", (id, name) => {
      return this.uploadValidate(id, name)
    })
    this.uploader.on("upload", (id, name) => {
      this.onUploadStart(id, name)
    })
    this.uploader.on("error", (id, name, errorReason) => {
      this.onUploadError(id, name, errorReason)
    })
    this.uploader.on("allComplete", (succeeded, failed) => {
      if (succeeded.length > 0) {
        this.onUploadSuccess(succeeded.shift())
      }
    })
  }

  onUploadStart(id) {
    this.setState({
      uploadStatus: "PROGRESS",
    })
  }

  onUploadError(id, errorReason) {
    this.setState({
      uploadStatus: "ERROR",
      uploaderErrorMessage: errorReason,
    })
  }

  getPublicUrl(id) {
    if (this.props.type === 's3') {
      return this.props.fineUploaderOptions.request.endpoint + "/" + this.uploader.methods.getKey(id);
    } else if (this.props.type === 'traditional') {
      return this.props.fineUploaderOptions.request.endpoint + "/show/" + this.uploader.methods.getUuid(id);
    }

    return null;
  }

  onUploadSuccess(id) {
    var publicUrl = this.getPublicUrl(id);
    this.setState({
      uploadStatus: "SUCCESS",
      uploadPublicUrl: publicUrl,
    });
    this.props.onSuccess && this.props.onSuccess(publicUrl);
  };

  // Do addition validation here, return false or a promise (and call reject()) to prevent uploading
  // https://docs.fineuploader.com/branch/master/api/events.html#submit
  uploadValidate(id) {
    var file = this.uploader.methods.getFile(id)
    var errors = []
    var isValidType = file.type.match(this.props.accept)
    if (!isValidType) {
      errors.push(this.props.invalidTypeMessage)
    }

    var isValidSize = file.size > 0 && file.size < 524288000 // 500*1024*1024
    if (!isValidSize) {
      errors.push("Het bestand is te groot.")
    }

    if (errors.length > 0) {
      this.setState({
        uploadValidationErrors: errors,
      })
    }
    else {
      this.setState({
        uploadValidationErrors: [],
      })
    }
    return !errors.length
  }

  render() {
    return (
      <div className="uploader">

        {this.state.uploadValidationErrors &&
          <div className={style.validations}>
            {this.state.uploadValidationErrors.join(" ")}
          </div>
        }

        {this.state.uploadStatus === "PROGRESS" &&
          <div className={style.status}>Je bestand wordt geüpload.</div>
        }

        {this.state.uploadStatus === "ERROR" &&
          <div className={[style.status, style.error].join(" ")}>Er is iets mis gegaan met uploaden. Probeer opnieuw. ({this.state.uploaderErrorMessage})</div>
        }

        {this.state.uploadStatus === "SUCCESS" &&
          <div className={style.status}>Je bestand is succesvol geüpload.</div>
        }

        <ProgressBar uploader={this.uploader} className={style.progressBar} />


        {(this.state.uploadStatus !== "PROGRESS" && this.state.uploadStatus !== "SUCCESS") &&
          <FileInput accept={this.props.accept} uploader={this.uploader} className={style.input}>
            <span className={style.label}>{this.props.label}</span>
          </FileInput>
        }

      </div>
    )
  }
}
